/** Website-only label. Keep canonical trim unchanged for feeds and structured data. */
export function vehicleTrimLabel(trim?: string, seriesDetail?: string): string {
    const parts = [trim, seriesDetail].map(value => value?.trim()).filter((value): value is string => Boolean(value));
    return parts.filter((value, index) => parts.findIndex(part => part.toLowerCase() === value.toLowerCase()) === index).join(" · ");
}
